import moment from "moment";
import { PERMISSIONS, USER_GROUPS } from "./config/config"
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import { saveAs } from "file-saver";


export const userGroups = () => {
    const groups = localStorage.getItem(USER_GROUPS) !== null ? JSON.parse(localStorage.getItem(USER_GROUPS)) : []
    return groups
}

export const generateUniqueID = () => {
    const timestamp = Date.now();
    const randomValue = Math.floor(100000 + Math.random() * 900000); // 6-digit random value
    return `${timestamp}${randomValue}`;
};

//  saving it in localStorage
export const getUniqueSocketBroadcastID = () => {
    let socketBroadcastID = localStorage.getItem('socket_broadcast_id');
    if (!socketBroadcastID) {
        socketBroadcastID = generateUniqueID();
        localStorage.setItem('socket_broadcast_id', socketBroadcastID);
    }
    return socketBroadcastID;
};


export const AccessModel = (accessKeyData, llms) => {
    // Map origin to proper company name
    const companyNameMap = {
        "openai": "OpenAI",
        "google": "Google",
        "bedrock": "Bedrock", // Assuming 'bedrock' refers to Anthropic Claude
        "anthropic": "Anthropic",
        "meta": "Meta",
        "mistral": "Mistral"
    };
    const accessOrigins = new Set(accessKeyData.map(item => item.origin)).add("bedrock");

    // Enhance models
    const updatedModels = llms.map(model => ({
        ...model,
        has_access: accessOrigins.has(model.origin),
        original_company_name: companyNameMap[model.origin] || model.origin
    }));

    return updatedModels
}

export const hasGroup = (group) => {
    const groups = userGroups()
    if (groups.includes(group)) {
        return true
    }
    return false
}
export const hasPermission = (permission) => {
    if (localStorage.getItem(PERMISSIONS) !== null) {
        const permissions = localStorage.getItem(PERMISSIONS).split(',');
        return permissions.includes(permission);
    }
    return false
}
export function arrayRemoveItem(arr, value) {
    return arr.filter(ele =>
        // console.log('ele',ele,'value',value)
        ele !== value
    );
}

export const getBuildDate = (epoch) => {
    const buildDate = moment(epoch).format("DD-MM-YYY HH:MM");
    return buildDate;
};
export function capitalize(string) {
    if (string !== undefined) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
    return ''
}

export function capitalizeFirstLetter(string = "") {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function uniqueElements(array) {
    return array.filter((v, i, a) => a.indexOf(v) === i);
}

export const isEmailOrPhone = (val) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const phoneRegex = /^(\+91-|\+91|0)?\d{10}$/;
    let result = null;
    if (emailRegex.test(val)) {
        result = 'EMAIL'
    }
    else if (phoneRegex.test(val)) {
        result = 'PHONE'
    }
    return result;
}

export const generateRandomPassword = (length = 8, options = {}) => {
    const {
        includeUppercase = true,
        includeLowercase = true,
        includeNumbers = true,
        includeSymbols = true,
        excludeAmbiguous = false
    } = options;

    // Character sets
    const lowercase = 'abcdefghijklmnopqrstuvwxyz';
    const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    // Ambiguous characters to exclude if needed

    let charset = '';
    const requiredChars = [];

    // Build character set and ensure at least one of each required type
    if (includeLowercase) {
        const lowerChars = excludeAmbiguous ? lowercase.replace(/[1l]/g, '') : lowercase;
        charset += lowerChars;
        requiredChars.push(lowerChars[Math.floor(Math.random() * lowerChars.length)]);
    }

    if (includeUppercase) {
        const upperChars = excludeAmbiguous ? uppercase.replace(/[O]/g, '') : uppercase;
        charset += upperChars;
        requiredChars.push(upperChars[Math.floor(Math.random() * upperChars.length)]);
    }

    if (includeNumbers) {
        const numberChars = excludeAmbiguous ? numbers.replace(/[0]/g, '') : numbers;
        charset += numberChars;
        requiredChars.push(numberChars[Math.floor(Math.random() * numberChars.length)]);
    }

    if (includeSymbols) {
        const symbolChars = excludeAmbiguous ? symbols.replace(/[|`]/g, '') : symbols;
        charset += symbolChars;
        requiredChars.push(symbolChars[Math.floor(Math.random() * symbolChars.length)]);
    }

    if (charset === '') {
        throw new Error('At least one character type must be included');
    }

    // Generate remaining characters
    const password = [...requiredChars];
    // eslint-disable-next-line no-plusplus
    for (let i = requiredChars.length; i < length; i++) {
        password.push(charset[Math.floor(Math.random() * charset.length)]);
    }

    // Shuffle the password array to randomize positions
    // eslint-disable-next-line no-plusplus
    for (let i = password.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [password[i], password[j]] = [password[j], password[i]];
    }

    return password.join('');
};

/**
 * Simple 8-character password generator (default settings)
 * @returns {string} 8-character password with mixed case, numbers, and symbols
 */
export const generateSimplePassword = () => generateRandomPassword(8);

/**
 * Generate secure password for supervisor accounts
 * @returns {string} 8-character secure password
 */
export const generateSupervisorPassword = () => generateRandomPassword(8, {
    includeUppercase: true,
    includeLowercase: true,
    includeNumbers: true,
    includeSymbols: false, // No symbols for easier typing
    excludeAmbiguous: true // Exclude confusing characters
});


export function isPlainObject(value) {
    return typeof value === 'object' && value !== null && value.constructor === Object;
}